import './Footer.scss'
import {getPropsFromState} from "../../redux/mapStateToProps";
import {connect} from "react-redux";
import {FooterFacebookIcon, FooterInstagramIcon, Logo, TelegramIcon, YoutubeIcon} from "../../assets/images";
import React from "react";
import {Link, NavLink} from "react-router-dom";
import Socials from "../socials/Socials";

function Footer(props) {
    const {contacts,staticTexts} = props

    return <div className={'footer-wrapper'}>
        <div className={'footer-top-block'}>
            <Link to={'/'} className={'footer-logo-wrapper'}>
                <Logo/>
            </Link>
            <div className={'footer-info-block'}>
                <div className={'footer-blocks'}>
                    <NavLink to={'/event'} activeClassName='active'>
                        <li className="nav-item">{staticTexts?.footer_item_events}</li>
                    </NavLink>
                    <NavLink to={'/video'} activeClassName='active'>
                        <li className="nav-item">{staticTexts?.footer_item_videos}</li>
                    </NavLink>
                    <NavLink to={'/travel'} activeClassName='active'>
                        <li className="nav-item">{staticTexts?.footer_item_traveling}</li>
                    </NavLink>
                    <NavLink to={'/project'} activeClassName='active'>
                        <li className="nav-item">{staticTexts?.footer_item_projects}</li>
                    </NavLink>
                </div>
                <div className={'footer-pages'}>
                    <NavLink to={'/about'} activeClassName='active'>
                        <li className="nav-item">{staticTexts?.footer_item_about}</li>
                    </NavLink>
                    <NavLink to={'/contact'} activeClassName='active'>
                        <li className="nav-item">{staticTexts?.footer_item_contact}</li>
                    </NavLink>
                </div>
                <div className={'footer-socials'}>
                    <div className={'footer-socials-header'}>
                        <div className={'footer-social-title'}>
                            {staticTexts?.footer_social_medias}
                        </div>
                        <Socials contacts={contacts}/>
                    </div>
                    <div className={'footer-developed'}>
                        <span>{staticTexts?.footer_developed}</span> <a href={'https://solidy.am/'} target={'_blank'}>Solidy</a>
                    </div>
                </div>
            </div>
        </div>
        <div className={'footer-bottom-block'}>
            {staticTexts?.footer_cooperation}
        </div>
    </div>
}const mapStateToProps = (state) => {
    return getPropsFromState(state, [
        'staticTexts',
        'languages',
        'contacts',
    ])
};
const mapDispatchToProps = {

};
export default connect(mapStateToProps,mapDispatchToProps)(Footer);